module.exports = __webpack_public_path__ + "img/whiteLock.f75ebb2e.svg";